"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
var ClientReduxProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ClientReduxProvider, _super);
    function ClientReduxProvider(appReducer, middlewares, withDevTools) {
        if (withDevTools === void 0) { withDevTools = true; }
        var _this = this;
        var preloadedState = window.__PRELOADED_STATE__ || {};
        delete window.__PRELOADED_STATE__;
        _this = _super.call(this, redux_1.createStore(appReducer, preloadedState, ((withDevTools && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
            redux_1.compose)(redux_1.applyMiddleware.apply(void 0, middlewares)))) || this;
        return _this;
    }
    ClientReduxProvider.prototype.component = function (children) {
        return React.createElement(react_redux_1.Provider, { store: this.provider }, children);
    };
    return ClientReduxProvider;
}(BaseProvider_1.BaseProvider));
exports.ClientReduxProvider = ClientReduxProvider;
//# sourceMappingURL=ClientReduxProvider.js.map